import { validateSync } from "class-validator"
import { intersection } from "lodash"
import qs from "qs"
import { useMemo } from "react"

export const useSearch = () => {
  const search = window.location.search
  return useMemo(
    () =>
      qs.parse(search.slice(1), {
        strictNullHandling: true,
      }),
    [search]
  )
}

export const useValidateSearch = <T extends object>(type: { new (): T }) => {
  const search = useSearch()
  const cls = useMemo(() => new type(), [type])
  const intersectedKey = useMemo(() => intersection(Object.keys(cls), Object.keys(search)), [cls, search])
  const data = useMemo(() => Object.assign(cls, search), [cls, search])
  const errors = useMemo(() => validateSync(data), [data])

  return {
    data,
    intersectedKey,
    errors,
  }
}
